import { Component, Input } from '@angular/core';
import { StoreConfigStatus } from '@app/store/store-grid';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'txp-store-config-status',
  templateUrl: './store-config-status.component.html',
  styleUrls: ['./store-config-status.component.scss'],
  standalone: true,
  imports: [NgClass, TranslateModule],
})
export class StoreConfigStatusComponent {
  @Input() data: StoreConfigStatus;

  getIcon(isChecked: boolean): string {
    if (isChecked) {
      return 'tce-icon-circle-check passed';
    } else {
      return 'tce-icon-circle-cross failed';
    }
  }
}
